const frCA = {
  'INTEGRATIONS.ServiceNow.discovery.CONNECTIONNAME.title':
    'Nom de la source de détection',
  'INTEGRATIONS.ServiceNow.discovery.USERNAME.title': 'ID d’utilisateur',
  'INTEGRATIONS.ServiceNow.discovery.INSTANCENAME.title': 'URL ServiceNow',
  'INTEGRATIONS.ServiceNow.discovery.PASSWORD.title': 'Mot de passe',
  'INTEGRATIONS.SERVICENOW.URL.VALIDATION_ERROR1': 'URL non valide',
  'INTEGRATIONS.LABEL.DISCOVERY_FREQUENCY': 'Fréquence de détection',
  'INTEGRATIONS.DESCRIPTION.KBA_PROMPT':
    'Invitez les utilisateurs à répondre aux questions d’authentification basées sur les connaissances (KBA).',
  'INTEGRATIONS.DISCOVERY.DESCRIPTION':
    'Détectez vos applications et vos données utiles au moyen de l’une de ces sources de détection populaires. Vous pourrez accéder à des avantages comme les détails préremplis, les recommandations priorisées et une vue complète de l’état d’intégration.',
  'INTEGRATIONS.DISCOVERY.BACK': 'Retour',
  'INTEGRATIONS.DISCOVERY.TITLE': 'Configurer la détection',
  'INTEGRATIONS.DISCOVERY.COMINGSOON': 'Bientôt disponible...',
  'INTEGRATIONS.DISCOVERY.LEARNMORE': 'En savoir plus',
  'INTEGRATIONS.DISCOVERY.CONNECTION.APPLICATION.SETUP.DESCRIPTION':
    'Entrez vos authentifiants de l’application pour établir une connexion. Une fois la connexion établie, vous pourrez importer des données.',
  'INTEGRATIONS.DISCOVERY.ERROR.HEADING':
    'Une erreur est survenue lors du chargement de la page.',
  'INTEGRATIONS.DISCOVERY.ERROR.SUBHEADING':
    'Essayez d’actualiser, ou revenez plus tard. Si le problème persiste, contactez votre administrateur.',
  'INTEGRATIONS.DISCOVERY.ERROR.RELOAD': 'Recharger',
  'INTEGRATIONS.ServiceNow.discovery.CONNECTION_SETTINGS.title':
    'Paramètres de la connexion',
  'INTEGRATIONS.ServiceNow.discovery.CI_CLASSES.title': 'Classes de CI***',
  'INTEGRATIONS.ServiceNow.discovery.ATTRIBUTE_MAPPING.title':
    'Mappage des attributs',
  'INTEGRATIONS.Feature.Basic.ServiceNow.discovery.Conn.Title':
    'Détails de la connexion',
  'INTEGRATIONS.BUTTON.SAVE': 'Sauvegarder',
  'INTEGRATIONS.DISCOVERY.SELECT': 'Sélectionner',
  'INTEGRATIONS.DISCOVERY.CREATE_NEW_CONNECTION':
    'Créer une nouvelle connexion',
  'INTEGRATIONS.DISCOVERY.USE_THIS_CONNECTION': 'Utiliser cette connexion',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED': 'ServiceNow enregistré!',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.DESCRIPTION':
    'Votre connexion à la source de détection ServiceNow a bien été testée et enregistrée. Importez les données pour terminer la configuration de la détection. Vous pouvez ignorer...',
  'INTEGRATIONS.DISCOVERY.IMPORT': 'Importer les actifs',
  'INTEGRATIONS.DISCOVERY.SKIP_FOR_NOW': 'Ignorer pour le moment',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.INLINE':
    'Une fois l’importation commencée, elle ne peut pas être annulée',
  'INTEGRATION.DISCOVERY.SETUP.GUIDE_ME': 'Me guider',
  'INTEGRATION.DISCOVERY.SELECT_EXISTING':
    'Sélectionner une connexion existante',
  'INTEGRATION.DISCOVERY.CONNECTION.NAME': 'Nom de la connexion',
  'INTEGRATION.EXISTING.CONNECTION.SUBTEXT':
    'Nous avons détecté {total, plural, one {une configuration de connexion existante} other {#}} configurations de connexion existantes :',
  'INTEGRATIONS.FILEUPLOAD.STARTIMPORT': 'Commencer l’importation',
  'INTEGRATIONS.FILEUPLOAD.IMPORTINGDATA':
    'Importation des données à partir d’un fichier Excel. Veuillez patienter...',
  'INTEGRATIONS.TRY.AGAIN': 'Réessayez',
  'INTEGRATIONS.CLOSE': 'Fermer',
  'INTEGRATIONS.ERROR.CONNECTION': 'Erreur de connexion. Veuillez réessayer.',
  'INTEGRATIONS.FILEUPLOAD.SUCCESS':
    'Vous pouvez quitter la page en attendant. Nous vous informerons une fois que le processus sera terminé.',
  'INTEGRATIONS.FILEUPLOAD.MODAL.TITLE': 'Importer la source de détection',
  'INTEGRATIONS.FILEUPLOAD.HEADING':
    'Importer la source de détection à partir d’un fichier',
  'INTEGRATIONS.FILEUPLOAD.DOWNLOAD_SAMPLE':
    'Télécharger un exemple de fichier',
  'INTEGRATIONS.FILEUPLOAD.INPUT_LABEL': 'Nom de la source de détection',
  'INTEGRATIONS.FILEUPLOAD.INPUT_PLACEHOLDER': 'Entrer le nom de fichier',
  'INTEGRATIONS.FILEUPLOAD.INVALID_NAME':
    'Veuillez entrer un nom valide. Seuls les lettres, les chiffres et certains symboles sont autorisés.',
  'INTEGRATIONS.FILEUPLOAD.UPLOADING': 'Téléversement...',
  'INTEGRATIONS.FILEUPLOAD.CONTINUE': 'Continuer',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.TITLE':
    'Voici les dix premiers enregistrements du fichier XLSX téléversé.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.MISSING_HEADER':
    'En-tête obligatoire manquant',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.COLUMN_ERRORS_SUFFIX':
    'Erreurs de colonne détectées',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.FIX_ISSUES':
    'Veuillez corriger les problèmes avant de procéder à l’importation des données.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.EXCLUDE': 'Exclure de l’importation',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.TITLE':
    'Confirmation de l’intégration de l’application',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DESCRIPTION':
    'Nous avons identifié le type d’application. Veuillez confirmer s’il s’agit bien du type d’application que vous intégrez.',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DEFAULT_APP_DESC':
    'Le type d’application que vous intégrez est {applicationName}',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.SELECT_DIFFERENT':
    'Non, sélectionner dans une liste d’applications',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.CONFIRM':
    'Oui, c’est ce que j’intègre',
  'INTEGRATIONS.DASHBOARD.HEADER.TITLE': 'Intégrations',
  'INTEGRATIONS.DASHBOARD.HEADER.ADD_INTEGRATION': 'Ajouter une intégration',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.SEARCH': 'Aucun résultat trouvé pour',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER': 'Non',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER.SUFFIX': 'Intégrations trouvées.',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.HIDDEN': 'Aucune intégration disponible.',
  'INTEGRATIONS.DASHBOARD.APPLICATIONS_DISCOVERED': 'Applications détectées',
  'INTEGRATIONS.DASHBOARD.OWNER_LABEL': 'Propriétaire :',
  'INTEGRATIONS.DASHBOARD.LAST_DISCOVERED': 'Détecté pour la dernière fois le',
  'INTEGRATIONS.DASHBOARD.CONNECTION_FAILED': 'Échec de la connexion',
  'INTEGRATIONS.DASHBOARD.USERS_HAVE_ACCESS': 'Les utilisateurs ont accès',
  'INTEGRATIONS.DASHBOARD.CHIP_DISCOVERY_SOURCE': 'Source de détection',
  'INTEGRATIONS.BUTTON.ENABLE': 'Activer',
  'INTEGRATIONS.BUTTON.DISABLE': 'Désactiver',
  'INTEGRATIONS.ENABLING': 'Activation',
  'INTEGRATIONS.MODAL_TITLE.DISCOVERY': 'Détection',
  'INTEGRATIONS.DASHBOARD.REUPLOAD': 'Téléverser de nouveau',
  'INTEGRATIONS.DASHBOARD.ONBOARD': 'Intégrer',
  'INTEGRATIONS.DASHBOARD.HIDE': 'Masquer',
  'INTEGRATIONS.DASHBOARD.UNHIDE': 'Démasquer',
  'INTEGRATIONS.DISCOVERY.TABS_ARIA_LABEL':
    'Onglets de configuration de la détection',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_TITLE':
    'Annuler les modifications non enregistrées?',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_SUBTITLE':
    'Vous avez des modifications non enregistrées. Les modifications seront perdues si vous continuez.',
  'INTEGRATIONS.BUTTON.DISCARD_CHANGES': 'Annuler les modifications',
  'INTEGRATIONS.BUTTON.CANCEL': 'Annuler',
  'INTEGRATIONS.BUTTON.SAVE_ERROR_TITLE': 'Erreur d’enregistrement',
  'INTEGRATIONS.CMDB_HEADER.BACK_BUTTON_ARIA_LABEL':
    'Retourner à la page précédente',
  'INTEGRATIONS.CMDB_HEADER.IMAGE_ALT': 'Icône d’application',
  'INTEGRATIONS.CMDB_HEADER.RUN_MANUALLY_BUTTON': 'Exécuter manuellement',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_FAILED_TITLE':
    'Désactivation échouée',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_FAILED_TITLE': 'Activation échouée',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_SUCCESS_DESCRIPTION':
    'Désactivation réussie.',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_SUCCESS_DESCRIPTION':
    'Activation réussie.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT':
    'Une autre importation est en cours.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT.SUBHEADING':
    'Les actifs sont en cours d’importation par un autre processus. Veuillez réessayer ultérieurement.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.IMPORTFAILED': 'Importation échouée',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS':
    'Importation des actifs à partir de ServiceNow',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS.MESSAGE':
    'Vous pouvez quitter la page en attendant. Nous vous informerons une fois que le processus sera terminé.',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ROW_ARIA_LABEL':
    'Ajouter une nouvelle ligne de mappage des attributs',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ATTRIBUTE': 'Ajouter un attribut',
  'INTEGRATIONS.ATTRIBUTE_ROW.EMPTY_PLACEHOLDER': '(Vide)',
  'INTEGRATIONS.ATTRIBUTE_ROW.DELETE_ARIA_LABEL': 'Supprimer ce mappage',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SERVICENOW_FIELD': 'Champ ServiceNow',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SAVIYNT_FIELD': 'Champ Saviynt',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SERVICENOW':
    'Rechercher l’attribut ServiceNow',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SAVIYNT':
    'Rechercher l’attribut Saviynt',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.CUSTOM_SUFFIX': '(Personnalisation)',
  'INTEGRATIONS.ERROR.SAVE_FAILED': 'Enregistrement échoué',
  'INTEGRATIONS.SCHEDULING.ARIA_LABEL': 'Configuration de la planification',
  'INTEGRATIONS.SCHEDULING.REPEATS_AT': 'à {timeLabel} (UTC).',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_TITLE': 'Répéter le',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_DAYS_GROUP': 'Répéter les jours',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.LABEL.REPEAT_EVERY': 'Répéter chaque',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.PLACEHOLDER.ENTER_INTERVAL':
    'Entrer l’intervalle',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.ARIA_LABEL.REPEAT_INTERVAL':
    'Intervalle de répétition en nombre de jours, de semaines ou de mois',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.DAY': 'Jour',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.WEEK': 'Semaine(s)',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.MONTH': 'Mois',
  'INTEGRATIONS.DAYS.SUN': 'Dim',
  'INTEGRATIONS.DAYS.MON': 'Lun',
  'INTEGRATIONS.DAYS.TUE': 'Mar',
  'INTEGRATIONS.DAYS.WED': 'Mer',
  'INTEGRATIONS.DAYS.THU': 'Jeu',
  'INTEGRATIONS.DAYS.FRI': 'Ven',
  'INTEGRATIONS.DAYS.SAT': 'Sam',
  'INTEGRATIONS.BUTTON.DISABLING': 'Désactivation',
  'INTEGRATIONS.BUTTON.SAVED': 'Enregistré',
  'INTEGRATIONS.BUTTON.SAVING': 'Enregistrement',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_TITLE':
    'Souhaitez-vous vraiment désactiver ',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_SUBTITLE':
    'En désactivant la source de détection, l’importation des actifs cessera, et vous ne pourrez pas configurer la source.',
  'INTEGRATIONS.DISCOVERY.HERE': 'ici',
  'INTEGRATIONS.DISCOVERY.EXISTING.CONNECTION.FAILED':
    'Votre source de détection a bien été créée, mais la connexion à ServiceNow a échoué. Pour commencer à importer des actifs, veuillez mettre à jour les détails de la connexion à la page de configuration de la source de détection ',
};

export default frCA;
